<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .license-card {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(16px);
    border: 1px solid colors.get(interfaceSwGrey_10);
    border-radius: utils.in_rem(16px);
    padding: utils.in_rem(12px);
  }
</style>

<script>
  import Header from "./Header.svelte";
  import TeamBody from "./TeamBody.svelte";
  import UserBody from "./UserBody.svelte";

  let { mod, max = null, notification = "" } = $props();
</script>

<div class="license-card">
  <Header {mod} {notification} />
  {#if mod.permissionObject === "user"}
    <UserBody {mod} {max} />
  {:else if mod.permissionObject === "team"}
    <TeamBody {mod} />
  {/if}
</div>
